import React from 'react';

interface WorkTypeBadgeProps {
  /** True for a PBS-local opportunity, false for a Redmine project. */
  isOpportunity: boolean;
  className?: string;
}

/**
 * Tells an opportunity apart from a Redmine project at a glance.
 *
 * Purple "Opportunity" matches the badge the project picker already uses
 * (ProjectSelector), so the same colour means the same thing everywhere.
 */
const WorkTypeBadge: React.FC<WorkTypeBadgeProps> = ({ isOpportunity, className = '' }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
      isOpportunity ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'
    } ${className}`}
  >
    {isOpportunity ? 'Opportunity' : 'Project'}
  </span>
);

export default WorkTypeBadge;
